import { render, staticRenderFns } from "./RemoveLdpDialog.vue?vue&type=template&id=d3fa821a&scoped=true&"
import script from "@/components/curriculum/RemoveLdpDialog/RemoveLdpDialog.ts?vue&type=script&lang=ts&"
export * from "@/components/curriculum/RemoveLdpDialog/RemoveLdpDialog.ts?vue&type=script&lang=ts&"
import style0 from "./RemoveLdpDialog.vue?vue&type=style&index=0&id=d3fa821a&prod&lang=scss&scoped=true&"
import style1 from "./RemoveLdpDialog.vue?vue&type=style&index=1&id=d3fa821a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3fa821a",
  null
  
)

export default component.exports